import { observer } from 'mobx-react';
import React from 'react';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { ToBeDone } from '../ToBeDone';

export const SendMessagePage = observer(function() {
	useNoSubmenu();
	return <ToBeDone/>;
});
